<template>
  <button class="icon-button" :style="iconSize">
    <fa :icon="icon" :type="iconType"></fa>
  </button>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "IconButton",

  props: {
    icon: {
      type: String,
      required: true
    },

    iconType: {
      type: String,
      default: "fas",
      required: false
    },

    width: {
      type: String,
      default: "30px",
      required: false
    },

    height: {
      type: String,
      default: "30px",
      required: false
    }
  },

  computed: {
    iconSize(): string {
      return `width: ${this.width}; height: ${this.height};`;
    }
  }
});
</script>

<style lang="scss" scoped>
.icon-button {
  border: none;
  background: none;
}
</style>
